import { compose, withProps, mapProps, withHandlers } from 'recompose'
import { connect } from 'react-redux'
import { reduxForm } from 'redux-form'
import withNormalizeValue from 'components/common/hoc/withNormalizeValue'
import { convertSortToOptions } from 'helpers/options'
import SortByForm from './SortByForm'
import { SORT_BY_FORM_NAME, SORT_BY_INPUT_NAME, SORT_BY_INPUT_LABEL } from './constants'
import { getSelectedValue } from '../helpers'
import { filterItems } from '../actions'

const mapSortOptions = mapProps(({ sortOptions, ...props }) => ({
  ...props,
  options: convertSortToOptions(sortOptions)
}))

const withSortFormInitialValues = withProps(({ options }) => ({
  initialValues: {
    sortBy: getSelectedValue(options)
  }
}))

const withSortFormViewModel = withProps(({ options }) => ({
  vm: {
    name: SORT_BY_INPUT_NAME,
    label: SORT_BY_INPUT_LABEL,
    options,
    isSearchable: false
  }
}))

const withSortFormHandlers = withHandlers({
  handleFilterChange: ({ options, filterItems }) => ({ value } = {}) => {
    filterItems({ navigationState: value })
  }
})

export default compose(
  connect(null, { filterItems }),
  mapSortOptions,
  withSortFormInitialValues,
  withSortFormViewModel,
  withSortFormHandlers,
  reduxForm({ form: SORT_BY_FORM_NAME }),
  withNormalizeValue
)(SortByForm)
